exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n.no-print[data-v-42c83aeb], .no-print *[data-v-42c83aeb] {\n    display: none !important;\n}\n.uk-width-medium-5-10[data-v-42c83aeb] {\n    width: 50% !important;\n}\n}", ""]);

// exports
